import { render, staticRenderFns } from "./appEducations.vue?vue&type=template&id=781002c0&scoped=true"
import script from "./appEducations.vue?vue&type=script&lang=js"
export * from "./appEducations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781002c0",
  null
  
)

export default component.exports